export default {
  'header.description': 'IT Tools',
  'header.PROJECT_NAME': 'IT Tools',
  home: 'home',
  'login.logout': 'Logout',

  'Note Download Tips': 'Note: Please download and close the app promptly once the conversion is done, as the data will be cleared.',
  待处理: 'Processing',
  待下载: 'Download',
  处理失败: 'Failed',
  '请问需要什么资料？': 'What information do you need?',
  '输入文件名、关键词或标签': 'Please enter the file name, keyword or tag',
  '目录浏览': 'Browse catalog',
  '最新资料': 'Latest information',
  '跳转首页': 'Return to home page',
  '下载文件': 'Download file',
  '预览文件': 'Preview file',
  '为你找到': 'Found',
  '相关的': 'files related to',
  '个文件：': ': ',
  '更新于：': 'Updated on ',
  '文件夹内文件内容描述': 'Description of files in the folder',
  // 通用
  Delete: 'Delete',
  Edit: 'Edit',
  'No Permission': 'No Permission',
  'Server Error': 'Server Error',
  // Watermark Agent landing page
  '工具集 · Watermark': 'IT Tools · Watermark',
  '仍使用网页版 →': 'Use web version →',
  '加水印工具已升级': 'PDF Watermark has been upgraded',
  '不用再打开这个网页了，': 'No need to open this page anymore. ',
  '直接在飞书里跟 Agent 说一句话。': 'Just send a message to the Agent in Feishu.',
  '上传合同、选模板、填项目名——现在这三步都在飞书对话里完成，不用登录、不用记网址，水印结果几秒后直接发到你手上。': 'Upload contracts, choose templates, fill in project names — all three steps now happen right in the Feishu chat. No login, no URLs to remember; the watermarked result is sent to you within seconds.',
  '在飞书中打开 IT AI小助手 →': 'Open IT AI Assistant in Feishu →',
  '飞书搜索「IT AI小助手」即可开始': 'Search "IT AI Assistant" in Feishu to get started',
  '过渡期内网页版仍会保留，': 'The web version will be kept for now. ',
  '点此继续使用': 'Click to continue',
  '仍然习惯网页操作？': 'Still prefer the web experience? ',
  '点此继续使用网页版加水印工具': 'Continue using the web watermark tool here',
  '过渡期内持续可用，后续将逐步下线': 'Available throughout the transition period and will be phased out gradually',
  '重播': 'Replay',
};
